import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component that shows a native popup menu on Android.
// Falls back to the web dropdown controller when not in a native app.

export default class extends BridgeComponent {
  static component = "menu"
  static targets = ["deleteForm"]
  static values = {
    items: Array,    // Array of { id: string, title: string, destructive?: boolean }
    editUrl: String, // URL for edit action
  }

  show(event) {
    if (!this.enabled) {
      // Not in native app - let the dropdown controller handle it
      return
    }

    // Native app - show native menu and prevent web dropdown
    event.preventDefault()
    event.stopImmediatePropagation()

    // Build items with URLs for native navigation
    const items = this.itemsValue.map(item => {
      if (item.id === "edit" && this.hasEditUrlValue) {
        return { ...item, url: this.editUrlValue }
      }
      return item
    })

    this.send("show", { items }, (message) => {
      const selectedId = message?.data?.selectedId
      if (selectedId) {
        this.handleSelection(selectedId)
      }
    })
  }

  handleSelection(selectedId) {
    // Only handle actions that weren't navigated by native side
    switch (selectedId) {
      case "delete":
        if (this.hasDeleteFormTarget) {
          this.deleteFormTarget.requestSubmit()
        }
        break
      case "add_to_calendar":
        this.element.dispatchEvent(new CustomEvent("menu:add-to-calendar", { bubbles: false }))
        break
    }
  }
}
